export const getCoverageBySortCode = (state, memberGroupKey, sortCode) => {
    return state.policyData.billGroupData.memberGroups
        .find(memberGroup => memberGroup.memberGroupKey === memberGroupKey).coverages
        .find(coverage => coverage.product.compassGroupSortCode === sortCode);
};